import { gql } from '@apollo/client';

export const getSummaryPrice = gql`
  query getSummaryPrice {
    getSummaryPrice {
      totalClientFee
      totalClientPaid
      totalNotaryGet
      totalNotaryPaid
      totalClientBalance
      totalNotaryBalance
    }
  }
`;
